var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('menu-button');
export var GripButtonDefaultProps = {
  columns: 2,
  rows: 3,
  direction: 'vertical',
  style: {
    padding: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '4px'
  },
  gap: 2,
  colors: {
    background: 'transparent',
    border: 'transparent',
    hover: {
      border: 'mid'
    }
  },
  bumpProps: {
    size: 4,
    colors: {
      background: 'very-subtle',
      border: 'very-subtle',
      hover: {
        background: 'mid',
        border: 'mid'
      }
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    \n    ", ";\n\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n  "], ["\n    ", ";\n    ", ";\n    \n    ", ";\n\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n  "])), theme.REMOVE_BUTTON_STYLE, theme.APPLY_COLORS, function (_a) {
    var bumpColors = _a.bumpColors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), theme.APPLY_COLORS({
      colors: bumpColors,
      selector: cls.dot('bump')
    }));
  }, function (_a) {
    var gap = _a.gap;
    return gap;
  })
});
var RowStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: default;\n    display: flex;\n    flex-direction: row;\n    gap: ", "px;\n  "], ["\n    cursor: default;\n    display: flex;\n    flex-direction: row;\n    gap: ", "px;\n  "])), function (_a) {
    var gap = _a.gap;
    return gap;
  })
});
var BumpStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    cursor: default;\n\n    ", "\n  "], ["\n    display: block;\n    cursor: default;\n\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "])), size, size);
  })
});
// -------- Components -------->
var My = {
  NAME: 'GripButton',
  Container: styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Row: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Bump: styled.span.attrs(cls.attr('bump'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BumpStyles)
};
export var GripButton = React.forwardRef(function (props, ref) {
  var componentProps = useComponentProps(My.NAME, GripButtonDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    style = componentProps.style,
    rows = componentProps.rows,
    gap = componentProps.gap,
    columns = componentProps.columns,
    colors = componentProps.colors,
    title = componentProps.title,
    bumpProps = componentProps.bumpProps,
    onClick = componentProps.onClick,
    rest = __rest(componentProps, ["className", "children", "style", "rows", "gap", "columns", "colors", "title", "bumpProps", "onClick"]);
  return React.createElement(My.Container, __assign({
    type: "button",
    ref: ref,
    onClick: onClick,
    title: title,
    bumpColors: bumpProps.colors,
    style: style,
    gap: gap,
    colors: colors
  }, rest, {
    className: cls.name(className)
  }), Array.from({
    length: rows
  }).map(function (_, i) {
    return React.createElement(My.Row, {
      gap: gap,
      key: i
    }, Array.from({
      length: columns
    }).map(function (_, j) {
      return React.createElement(My.Bump, __assign({}, bumpProps, {
        key: j
      }));
    }));
  }));
});
/* @ts-ignore */
GripButton.cls = cls;
export var EllipsisGripButton = React.forwardRef(function (props, ref) {
  return React.createElement(GripButton, __assign({}, props, {
    ref: ref,
    gap: 3,
    columns: 3,
    rows: 1
  }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;